import axiosInstance from "./axiosInstance";

const normalizeScope = (scope = "") => {
    if (scope && typeof scope === "object") return scope;
    return { branchId: scope };
};

const branchScopeParam = (scope = "") => {
    const { branchId = "", customerId = "" } = normalizeScope(scope);
    return {
        branch_id: branchId || "default",
        ...(customerId ? { customer_id: customerId } : {}),
    };
};

export const fetchPrinterSettings = (scope = "") => axiosInstance.get("/admin/printer/settings", {
    params: branchScopeParam(scope),
});

export const savePrinterSettings = (settings, logoFile = null, removeLogo = false) => {
    const payload = { ...settings, remove_receipt_logo: removeLogo };
    if (!logoFile) return axiosInstance.put("/admin/printer/settings", payload);
    const data = new FormData();
    Object.entries(payload).forEach(([key, value]) => {
        if (value !== null && value !== undefined && typeof value !== "object") data.append(key, String(value));
    });
    data.append("receipt_logo", logoFile);
    return axiosInstance.put("/admin/printer/settings", data);
};

export const testPrinterConnection = (scope = "") => axiosInstance.post("/admin/printer/test-connection", {
    ...branchScopeParam(scope),
});

export const printTestReceipt = (scope = "") => axiosInstance.post("/admin/printer/test-receipt", {
    ...branchScopeParam(scope),
});

export const printBarcodeLabel = (payload) => axiosInstance.post("/admin/printer/barcode-label", payload);

export const fetchBridgeApkInfo = () => axiosInstance.get("/admin/printer/bridge-apk");

export const downloadBridgeApk = () => axiosInstance.get("/admin/printer/bridge-apk/download", {
    responseType: "blob",
});
